module.exports = __webpack_public_path__ + "static/media/employee_accordion.5a5d6890.webp";